/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  GetMedicationsErrorResponse,
  GetMedicationsParams,
  GetMedicationsResponse,
} from './api.schemas';

import { api } from '../util/http';

export const getMedications = (params?: GetMedicationsParams, signal?: AbortSignal) => {
  return api<GetMedicationsResponse>({ url: `/api/medications`, method: 'GET', params, signal });
};

export const getGetMedicationsQueryKey = (params?: GetMedicationsParams) => {
  return [`/api/medications`, ...(params ? [params] : [])] as const;
};

export const getGetMedicationsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMedications>>,
  TError = GetMedicationsErrorResponse,
>(
  params?: GetMedicationsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMedications>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMedicationsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMedications>>> = ({ signal }) =>
    getMedications(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMedications>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMedicationsQueryResult = NonNullable<Awaited<ReturnType<typeof getMedications>>>;
export type GetMedicationsQueryError = GetMedicationsErrorResponse;

export function useGetMedications<
  TData = Awaited<ReturnType<typeof getMedications>>,
  TError = GetMedicationsErrorResponse,
>(
  params: undefined | GetMedicationsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMedications>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMedications>>,
          TError,
          Awaited<ReturnType<typeof getMedications>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMedications<
  TData = Awaited<ReturnType<typeof getMedications>>,
  TError = GetMedicationsErrorResponse,
>(
  params?: GetMedicationsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMedications>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMedications>>,
          TError,
          Awaited<ReturnType<typeof getMedications>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMedications<
  TData = Awaited<ReturnType<typeof getMedications>>,
  TError = GetMedicationsErrorResponse,
>(
  params?: GetMedicationsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMedications>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetMedications<
  TData = Awaited<ReturnType<typeof getMedications>>,
  TError = GetMedicationsErrorResponse,
>(
  params?: GetMedicationsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMedications>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMedicationsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
